import { Component, OnInit, Input } from '@angular/core';
import * as CanvasJS from '../../assets/canvasjs.min';
import { RecordsService } from '../services/records.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-canvas-pays',
  templateUrl: './canvas-pays.component.html',
  styleUrls: ['./canvas-pays.component.css']
})
export class CanvasPaysComponent implements OnInit {

  
  public link: string;
  public chart: any;

  @Input() set linkv(val: string) {
    this.link = val;
    console.log(this.link);
    this.chargechart(this.link);
  }

  public pays: any;

  constructor(public recordservice: RecordsService, public translate: TranslateService) {
    this.chart = "";
    console.log(this.link);
    this.translate.onLangChange.subscribe(() => {
       this.chargechart(this.link);
    });
  }

	ngOnInit() {
    this.link ='http://trad.fondation.org.ma:8090/api/paysedit/'+this.translate.currentLang;
    this.chargechart(this.link);
  }

  public chargechart(link: string) {
      this.recordservice.getFilters(link)
      .subscribe(datan => {
        this.pays = datan;
        this.chart = new CanvasJS.Chart("chartContainer", {
          theme: "light2",
          animationEnabled: true,
          exportEnabled: true,
          title:{
            text: "Pays d'édition"
          },
          data: [{
            type: "pie",
            showInLegend: true,
            toolTipContent: "<b>{name}</b>: {y}\n - (#percent%)",
            indexLabel: "{name} : {y} - (#percent%)",
            dataPoints: this.pays
          }]
        });
          
        this.chart.render()
      }, err =>{
        console.log(err);
      });
  }

}
